import {ChartingDataParams, ChartingVariable, Client} from "../../../../autogenerate/api.generated.clients";

export const useChartingDataExport = function () {
    return {chartData: (chartData: ChartingDataParams) => new Client().chart_GetChartDataForExport(chartData)};
}